import { API } from '@Providers';

export default async function (lineId: string) {
  const endpoint = `/api/shelter/foster/remove-equipment-rental-line/${encodeURIComponent(lineId)}`;

  return API({ endpoint, method: 'post', payload: {} });
}
